import styled from 'styled-components'
import { colors } from '../../../../../../shared/styles/colors'

export const HiddenContainer = styled.div`
  display: none;
`
export const Container = styled.div`
  background-color: ${colors.white};
  display: flex;
  margin-top: 40px;
  width: 500px;
  margin-left: 20%;
  padding: 16px;
  align-items: center !important;
  align-content: center !important;
  justify-content: center !important;
  border: 1px solid ${colors.gray};
`

export const Box = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
  width: 100%;
  height: 100%;
`

export const Divider = styled.hr`
  margin-top: 16px;
  margin-bottom: 16px;
  border: 0.5px solid ${colors.lightGrey};
  margin-right: 24px;
`

export const BoxAvisoPagamentoAgendado = styled.div`
  background-color: ${colors.gray5};
  font-family: Inter, Roboto, sans-serif;
  padding: 16px;
  margin-right: 32px;
  border-radius: 8px;
`
